"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _settingsResolver = _interopRequireDefault(require("../../settingsResolver"));

var _debugLogger = _interopRequireDefault(require("../../utils/debugLogger"));

var refreshAccessToken = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(baseSettings, loginHandler) {
    var refreshToken, settings, body;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            refreshToken = sessionStorage.getItem('auth.refreshToken');
            _context.next = 3;
            return (0, _settingsResolver.default)(baseSettings);

          case 3:
            settings = _context.sent;
            (0, _debugLogger.default)('building request for new access token', settings.debug);
            body = new URLSearchParams();
            body.append('refresh_token', refreshToken);
            body.append('client_id', settings.clientId);
            body.append('grant_type', 'refresh_token');
            return _context.abrupt("return", fetch(settings.token, {
              method: 'post',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: body.toString()
            }).then(function (data) {
              if (!data.ok) {
                throw new Error({
                  error_description: data.statusText
                });
              }

              return data.json();
            }).then(function (response) {
              (0, _debugLogger.default)('access token updated', settings.debug); // Update refresh token with new one, and update access token

              sessionStorage.setItem('auth.accessToken', response.access_token);
              sessionStorage.setItem('auth.refreshToken', response.refresh_token);
            }).catch(function () {
              (0, _debugLogger.default)('failed to refresh token', settings.debug);
              window.location.assign(loginHandler);
            }));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function refreshAccessToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _default = refreshAccessToken;
exports.default = _default;